// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "javascript/chunks/" + "026e80d9e0c25132c13b" + ".min.js";
};